import { render, staticRenderFns } from "./SimpleKeyValueText.vue?vue&type=template&id=93b199b6&"
import script from "./SimpleKeyValueText.vue?vue&type=script&lang=js&"
export * from "./SimpleKeyValueText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93b199b6')) {
      api.createRecord('93b199b6', component.options)
    } else {
      api.reload('93b199b6', component.options)
    }
    module.hot.accept("./SimpleKeyValueText.vue?vue&type=template&id=93b199b6&", function () {
      api.rerender('93b199b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/shared/components/formcomponents/SimpleKeyValueText.vue"
export default component.exports